import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import UserEditForm from './FormUser';
import { getAccessUser } from "../../services/auth";
import { Link } from 'react-router-dom';

class ModalDadosForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: JSON.parse(getAccessUser()),
    }
  }

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }))
  }

  render() {

    let closeBtn = '';
    let toggle = '';

    if (!JSON.parse(getAccessUser())) {
      closeBtn = <button className="close" onClick={this.toggle}>&times;</button>
      toggle = this.toggle
    }

    const label = this.props.buttonLabel

    let button = ''
    let title = ''

    button = <Link
      to="#"
      onClick={this.toggle}>
      {label} <i style={{ color: 'var(--dommus-color-2)' }} className="fas fa-user-cog"></i>
    </Link>
    title = label

    return (
      <div>
        {button}
        <Modal isOpen={this.state.modal} toggle={toggle} className={this.props.className}>
          <ModalHeader toggle={toggle} close={closeBtn}>{title}</ModalHeader>
          <ModalBody>
            <UserEditForm
              toggle={toggle}
              user={this.props.user}
            />
          </ModalBody>
        </Modal>
      </div>
    )
  }
}
export default ModalDadosForm